import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  TextField,
  MenuItem,
  Button,
  Box,
  InputLabel,
  Grid2,
  CircularProgress,
  Snackbar,
  Alert,
  Menu,
  Typography,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { selectTheme } from "../../../../store/reducers/theme";
import { useSelector } from "react-redux";
import axios from "axios";
import { FORM_URL, HOST } from "../../../../variables";
import { useEffect, useState } from "react";
import Overlay from "../../../../components/@ui/overlay/Overlay";
import Feedback from "../../../../components/@ui/feedback/Feedback";
import CenteredFeedbackContainer from "../../../../components/@ui/feedback/CenteredFeedbackContainer";
import PhoneInput from "../../../../components/@extended/inputs/PhoneInput";

// Validation Schema
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phone: yup
    .string()
    .matches(/^[0-9]+$/, "Phone must be a number")
    .min(10, "Phone must be at least 10 digits")
    .required("Phone is required"),
  message: yup.string(),
  company: yup.string(),
});

export default function ContactForm() {
  const [message, setMessage] = useState(null);
  const { resolvedMode } = useSelector(selectTheme);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (message) {
      // Automatically reset feedback status after a short delay
      const timer = setTimeout(() => {
        setMessage(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  const onSubmit = async (data) => {
    const formData = { ...data, type: "priseen" };
    try {
      const response = await axios.post(FORM_URL, formData);
      setMessage({
        type: "success",
        text: "Form submitted successfully! We will reach out to you soon",
      });
      reset(); // Clear the form after successful submission
    } catch (error) {
      let errorMessage = "Something went wrong!";
      if (error.response) {
        // Server responded with an error (4xx, 5xx)
        errorMessage =
          error.response.data?.message || JSON.stringify(error.response.data);
      } else if (error.request) {
        // No response was received
        errorMessage = "No response from server!";
      } else {
        // Error during setup
        errorMessage = error.message;
      }
      setMessage({
        type: "error",
        text: errorMessage,
      });
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: { xs: "100%", sm: "100%", md: "100%", lg: "750px" },
        position: "relative",
      }}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12 }}>
          {/* <InputLabel className="text-primary">Name*</InputLabel> */}
          <TextField
            variant="outlined"
            sx={customTextFieldStyles}
            size="small"
            // label="Name*"
            placeholder="Name*"
            {...register("name")}
            error={!!errors.name}
            helperText={errors.name?.message}
            className="w-full"
            required
            // defaultValue={""}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          {/* <InputLabel className="text-primary">Email*</InputLabel> */}
          <TextField
            variant="outlined"
            sx={customTextFieldStyles}
            size="small"
            placeholder="Email*"
            {...register("email")}
            error={!!errors.email}
            helperText={errors.email?.message}
            className="w-full"
            defaultValue={""}
            required
          />
        </Grid2>

        {/* <Grid2 size={{ xs: 12 }}>
          <TextField
            variant="outlined"
            sx={customTextFieldStyles}
            size="small"
            placeholder="Phone*"
            {...register("phone")}
            error={!!errors.phone}
            helperText={errors.phone?.message}
            className="w-full"
            defaultValue={""}
            required
          />
        </Grid2> */}

        <Grid2 size={{ xs: 12, md: 6 }}>
          {/* <InputLabel className="text-primary">Phone*</InputLabel> */}
          <PhoneInput
            name="phone"
            control={control}
            label="Your Phone Number"
            rules={{ required: "Phone number is required" }}
          />
        </Grid2>

        <Grid2 size={{ xs: 12 }}>
          {/* <InputLabel className="text-primary">Name*</InputLabel> */}
          <TextField
            variant="outlined"
            sx={customTextFieldStyles}
            size="small"
            // label="Name*"
            placeholder="Comapny Name"
            {...register("company")}
            error={!!errors.company}
            helperText={errors.company?.message}
            className="w-full"
            required
            // defaultValue={""}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6, md: 6, lg: 12 }}>
          <TextField
            sx={customTextFieldStyles}
            variant="outlined"
            size="small"
            select
            placeholder="Business Type"
            {...register("business_type")}
            error={!!errors.business_type}
            helperText={errors.business_type?.message}
            className="w-full"
            defaultValue={"restaurant"}
            slotProps={{
              select: {
                MenuProps: {
                  PaperProps: {
                    sx: {
                      backgroundColor: "#fff",
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="restaurant">Retailing</MenuItem>
            <MenuItem value="grocery-store">Food & Beverage</MenuItem>
            <MenuItem value="cafe">Services</MenuItem>
            <MenuItem value="other">Others</MenuItem>
          </TextField>
        </Grid2>

        {/* <Grid2 size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
          <TextField
            variant="outlined"
            sx={customTextFieldStyles}
            size="small"
            select
            placeholder="Country*"
            {...register("country")}
            error={!!errors.country}
            helperText={errors.country?.message}
            className="w-full"
            defaultValue={"pakistan"}
          >
            <MenuItem value="uae">United Arab Emirates</MenuItem>
            <MenuItem value="pakistan">Pakistan</MenuItem>
            <MenuItem value="sa">Saudia Arabia</MenuItem>
          </TextField>
        </Grid2> */}

        {/* <Grid2 size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
          <TextField
            variant="outlined"
            sx={customTextFieldStyles}
            size="small"
            select
            placeholder="Interested In*"
            {...register("interested_in")}
            error={!!errors.interested_in}
            helperText={errors.interested_in?.message}
            className="w-full"
            defaultValue={"demo"}
          >
            <Menu>
              <MenuItem value="vaseelah">Vaseelah</MenuItem>
              <MenuItem value="business_app">Business App</MenuItem>
              <MenuItem value="demo">Book a demo</MenuItem>
            </Menu>
          </TextField>
        </Grid2> */}

        <Grid2 size={{ xs: 12 }}>
          <TextField
            variant="outlined"
            placeholder="Explain your business type and inquiry."
            sx={customTextFieldStyles}
            size="small"
            {...register("interested_in")}
            error={!!errors.interested_in}
            helperText={errors.interested_in?.message}
            multiline
            rows={5}
            className="w-full"
            defaultValue={""}
            required
          />
        </Grid2>
      </Grid2>
      <Grid2 size={12}>
        <Button
          type="submit"
          variant="contained"
          sx={{ borderRadius: "1px", width: "100%" }}
          color={"secondary"}
          disabled={isSubmitting}
        >
          {/* <CircularProgress size={"18px"} className="mr-2" /> Submit */}
          {isSubmitting && (
            <CircularProgress size={"18px"} className="mr-2" />
          )}{" "}
          Submit
        </Button>
      </Grid2>

      {message && (
        <Grid2 size={12}>
          <div className="flex gap-2 iems-center">
            <TaskAltIcon />
            <Typography color="textSecondary" className="font-bold">
              Your response was successfully submitted. We will get back to you
              soon!
            </Typography>
          </div>
        </Grid2>
      )}

      {/* {(isSubmitting || message) && (
        <Feedback
          feedback={isSubmitting ? "Processing Form" : message.text}
          type={isSubmitting ? "loader" : message.type}
          sx={{
            position: "absolute",
            transform: "translate(-50%, -50%)",
            top: "50%",
            left: "50%",
          }}
        />
      )} */}
    </Box>
  );
}

// MUI Override Styles
const customTextFieldStyles = {
  "& .MuiInputBase-root": {
    color: "primary.main",
    backgroundColor: "#eee",
    borderRadius: "1px",
    border: "none",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      color: "primary.main",
      borderColor: "none", // Default border
    },
    "&:hover fieldset": {
      borderColor: "black", // Hover border
    },
    "&.Mui-focused fieldset": {
      borderColor: "secondary.main",
    },
  },
  "& .MuiInputLabel-root": {
    color: "black",
  },
  "& .MuiList-root": {
    backgroundColor: "black!improtant",
  },
  " .css-1toxriw-MuiList-root-MuiMenu-list": {
    backgroundColor: "black",
  },
  "& .MuiInputBase-input": {
    color: "black", // Ensures text is black
    caretColor: "black", // Sets the cursor color
    "&::placeholder": {
      color: "gray",
      opacity: 1,
    },
  },
  "& .MuiInputBase-input:focus": {
    borderColor: "secondary.main",
    // backgroundColor: "#fff",
    color: "primary.main", // Text color when focused and typing
  },
};
